import React from 'react'
import {
  Card,
  Row,
  Col,
  Statistic,
  Table,
  Button,
  Space,
} from 'antd'
import { DownloadOutlined, PrinterOutlined } from '@ant-design/icons'
import { useModulePermission } from '@/hooks/useModulePermission'
import '../Lead/LeadList.css'

const SalesPerformanceReport: React.FC = () => {
  const { canDownload } = useModulePermission('Reports')
  const salesData = [
    {
      key: '1',
      executive: 'Sales Executive 1',
      leadsGenerated: 12,
      leadsConverted: 4,
      revenue: 25000,
      avgDealValue: 6250,
    },
    {
      key: '2',
      executive: 'Sales Executive 2',
      leadsGenerated: 10,
      leadsConverted: 3,
      revenue: 18000,
      avgDealValue: 6000,
    },
  ]

  const columns = [
    { title: 'Sales Executive', dataIndex: 'executive', key: 'executive' },
    { title: 'Leads Generated', dataIndex: 'leadsGenerated', key: 'leadsGenerated' },
    { title: 'Leads Converted', dataIndex: 'leadsConverted', key: 'leadsConverted' },
    { title: 'Revenue (₹)', dataIndex: 'revenue', key: 'revenue' },
    { title: 'Avg Deal Value (₹)', dataIndex: 'avgDealValue', key: 'avgDealValue' },
  ]

  return (
    <div className="lead-list-container">
      <div className="list-header">
        <h2>Sales Performance Report</h2>
        <Space>
          {canDownload && <Button icon={<DownloadOutlined />}>Export Excel</Button>}
          <Button icon={<PrinterOutlined />}>Print</Button>
        </Space>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Top Performer"
              value="Exec 1"
              valueStyle={{ fontSize: '18px' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Total Leads"
              value={22}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Total Conversions"
              value={7}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Total Revenue"
              value={43000}
              prefix="₹"
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: '16px' }}>
        <h3>Sales Executive Performance</h3>
        <Table
          dataSource={salesData}
          columns={columns}
          pagination={{ defaultPageSize: 10, pageSizeOptions: ['10', '25', '50', '100'], showSizeChanger: true }}
          rowKey="key"
        />
      </Card>
    </div>
  )
}

export default SalesPerformanceReport
